
export const MiscType = {
  setOrderId: 'setOrderId',
  setPhone: 'setPhone',
  setAmount: 'setAmount',
  setTransactionId: 'setTransactionId',
  setTransactionTimeStamp: 'setTransactionTimeStamp',
  setOtp: "setOtp",
  setOrderServiceResponse: "setOrderServiceResponse",
  setMyCouponDetails: "setMyCouponDetails",
  setUserFirstName: 'setUserFirstName',
  setOtpRefNo: 'setOtpRefNo',
  setDeviceInfo: "setDeviceInfo",
  setUserRegisterData: "setUserRegisterData",
  setTxnLoader: "setTxnLoader",
  setUploadedFile: "setUploadedFile",
  setBannerResponse: "setBannerResponse",
  setAddCampaignTxnCount: "setAddCampaignTxnCount",
  setActiveLinkStatus: "setActiveLinkStatus",
  setMoneyTransferTotalAmount: "setMoneyTransferTotalAmount",
  setToken: "setToken",
  setAgentInfo: "setAgentInfo",
  setAddSenderRequest: "setAddSenderRequest",
  setAddSenderRequestUrl: "setAddSenderRequestUrl",
  setBenefisciaryList: "setBenefisciaryList",
  setAddBenefisciaryRequest: "setAddBenefisciaryRequest",
  setAddBenefisciaryRequestUrl: "setAddBenefisciaryRequestUrl",
  setStateDetails: "setStateDetails",
  setCityList: "setCityList",
  setBranchList: "setBranchList",
  setIfscCode: "setIfscCode",
  setSendersListDetails: "setSendersListDetails",
  selectedSender: "selecetedSender",
  setMoneyTransferSurChargeAmount: "setMoneyTransferSurChargeAmount",
  setBankDetails: "setBankDetails",
  selectedBankName: "selectedBankName",
  setSelecetedBankDetails: "setSelecetedBankDetails",
  setSelectedBankName: "setSelectedBankName",
  setSelectedBankId: "setSelectedBankId",
  setOtpResponse: "setOtpResponse",
  setBranchAddress: "setBranchAddress",
  setBeneSubDetails: "setBeneSubDetails",
  setCreteOrderReq: "setCreteOrderReq",
  setCreateOrderRes: "setCreateOrderRes",
  setBeneMoneyTransfer: "setBeneMoneyTransfer",
  setActiveStatus: "setActiveStatus",
  setLogOutWarningStatus: "setLogOutWarningStatus",
  setLoginTimestamp: "setLoginTimestamp",
  setTxnAmount: "setTxnAmount",
  setTxnsurcharge: "setTxnsurcharge",
  setTxntotalAmount: "setTxntotalAmount",
  setMoneyTransferProgress: "setMoneyTransferProgress",
  setStatusEnqResponse: "setStatusEnqResponse",
  setTxnHistoryResponse: "setTxnHistoryResponse",
  setCustomerLimit: "setCustomerLimit",
  selectedBeneList: "selectedBeneList",
  setTxnReportingData: "setTxnReportingData",
  setTxnHistoryElementNo: "setTxnHistoryElementNo",
  setTxnHistoryPaginationResponse: "setTxnHistoryPaginationResponse",
  setTotalSenders: "setTotalSenders",
  setSendersListPageDetails: "setSendersListPageDetails",
  setBankLogoList: "setBankLogoList",
  setSenderCustomerId: "setSenderCustomerId",
  setBeneCustomerId: "setBeneCustomerId",
  setGraphResponse: "setGraphResponse",
  setOtpForBeneVerification: "setOtpForBeneVerification",
  setBeneRegister: "setBeneRegister",
  setPartner:'setPartner',
  setRequesterId:'setRequesterId',
  setLogoName:'setLogoName',
  setClientRole:'setClientRole',
  setTaLoadPermission:'setTaLoadPermission',

  setFilterStartDate:'setFilterStartDate',
  setFilterEndDate:'setFilterEndDate',
  setMiscCallBackUrl:'setMiscCallBackUrl',

  setClaimResp:'setClaimResp',


  setRetailerBlanceShow:'setRetailerBlanceShow',
  setClaimLoadShow:'setClaimLoadShow',
  setRetailerBalanceVal:'setRetailerBalanceVal',
  setDashboardPageGraphMonth:'setDashboardPageGraphMonth',
  setTimeoutModal:'setTimeoutModal',

  setBillPayShow:'setBillPayShow',

  setRechargeShow:'setRechargeShow',
  setPayoutShow:'setPayoutShow',
  setAepsShow:'setAepsShow',
  setDMTShow:'setDMTShow',
  setKycShow:'setKycShow',
  setSavedOtpDetails:'setSavedOtpDetails',
  setErrMsg:'setErrMsg',

  setResetPasswordLoader:'setResetPasswordLoader',
  RESET: "RESET"
};